<template>
  <div>
    <!-- ============================================================== -->
    <!-- Main wrapper - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <section id="wrapper">
      <router-view/>
    </section>
  </div>
</template>

<script setup>
</script>

<style scoped>

</style>
